export const formatEsmNotificationDate = (timestamp: string | number | undefined, fallback = ''): string => {
    if (timestamp === undefined) return fallback;
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return fallback;
    return `${date.getMonth() + 1}/${date.getDate()}/${String(date.getFullYear()).slice(-2)}`;
};
